import { Navigate, useLocation } from 'react-router-dom'

function RedirectWithQuery({ to }: { to: string }) {
  const location = useLocation()

  return <Navigate to={`${to}${location.search}`} replace />
}

export default RedirectWithQuery
